<template>
    <div>
      <nav :class="$route.path == '/' ? 'bg-white': 'bg-[#e8e6fe]'"
    class=" w-full py-6 px-4 md:px-10">
  
          <div v-if="!user">
            <router-link to="/"><img src="../assets/images/medremindLogoNew.png" alt="MedAlert Logo" class="mr-3 h-6 sm:h-8 cursor-pointer"></router-link>
          </div>
  
          <!-- <div v-else>
            <router-link to="/admin-dashboard"><img src="../assets/images/medremindLogoNew.png" alt="MedAlert Logo" class="mr-3 h-6 sm:h-8 cursor-pointer"></router-link>
          </div>
   -->
          <div class="flex justify-end">
            <p class=" text-black font-euclid text-lg font-medium" v-if="user"> Welcome, <span class="text-medalertBlue">{{user.client.name}}</span  > -  <span> {{user.first_name}}</span> </p>
          </div>
  
          
          <div v-if="!user" class="flex md:order-2">
           <button @click="loginRouter" type="button" class=" border-2 border-medalertBlue text-medalertBlue  hover:bg-medalertBlue hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-3xl text-md px-7 py-1 text-center mr-3 md:mr-0 dark:bg-purple dark:hover:bg-blueHover dark:focus:ring-purple font-euclid">Login</button>
        </div>
  
          <!-- <div v-if="user" class="flex md:order-2">
              <router-link to="/login" @click="handleClick"><button type="button" class="text-white bg-medalertBlue hover:bg-purple focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-md px-7 py-2 text-center mr-3 md:mr-0 dark:bg-purple dark:hover:bg-purple dark:focus:ring-purple font-euclid">Log out</button></router-link>
          </div> -->
          
      </nav>
    </div>
  </template>
  
  <script>
  
  import {useStore} from 'vuex'
  import { computed } from 'vue'
  import { ref } from 'vue';
  import {useRouter} from 'vue-router'
  
  export default {
  
      name:'adminNavBar',
  
      setup(){
  
      const router = useRouter()
      const store = useStore()
    //   const userRole = store.state.userRole
    //   console.log(userRole)
      const user = store.state.user
  
  
      const handleClick = () => {
        store.dispatch('logout')
      }
  
      const loginRouter = () => {
        router.push('/login')
      }
  
      return { 
        handleClick,
        // userRole,
        user,
        loginRouter
        // user: computed(() => store.state.user) ,
  
      }
  
    },
  
    mounted(){
        // this.getUserRole();
      }
  
  }
  </script>
  
  <style>
  
  </style>